@use "foundation/mixins";
@use "foundation/responsive";

header.onboarding-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 5em;

  .spacer {
    width: 10%;

    @include responsive.tablet {
      width: 42px;
    }
  }

  h1 {
    @include mixins.ifttt-logo-with-tier-badge;
    text-align: center;
    width: fit-content;
    margin: 0;
    // `ifttt-logo-with-tier-badge` uses `margin-left` on the badge; use flex `gap` so spacing stays predictable.
    gap: 0.45em;

    img:nth-child(2) {
      margin-left: 0;
    }

    @include responsive.phone {
      gap: 8px;

      img:nth-child(1) {
        width: 92px;
        height: auto;
      }

      img:nth-child(2) {
        width: 68px;
        height: auto;
      }
    }
  }
}

.benefits {
  max-width: 550px !important;

  overflow: hidden;

  .dropdown, ul {
    transition-property: margin,opacity;
    transition-duration: 0.3s;
    transition-timing-function: ease;
  }

  .dropdown {
    text-align: center;
    font-size: mixins.em(20);
    font-weight: 700;
    margin-bottom: 3.75em;
    cursor: pointer;

    @include mixins.noselect;
    display: flex;
    align-items: center;
    justify-content: center;

    .chevron {
      margin-left: 0.25em;
    }
  }

  ul {
    overflow: hidden;

    display: grid;

    height: auto;
    margin-top: 1em;
    margin-bottom: 3em;

    justify-content: center;
    grid-template-columns: minmax(max-content, 50%) max-content;
    max-width: 1000px;
    position: relative;
    text-align: left;
    row-gap: 0.5rem;
    font-size: mixins.em(16);

    @include responsive.phone {
      max-width: min(550px, 100%);
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 10px;
      row-gap: 10px;
      justify-content: stretch;
    }

    li {
      position: relative;
      font-weight: 600;
      margin-left: 1.5em;
      &::before {
        background-image: url("../../../shared/components/icons/circle_check.svg");
        background-repeat: no-repeat;
        position: absolute;
        content: "";
        width: 1em;
        height: 1em;
        background-size: contain;
        left: -1.5em;
        top: 0;
      }
    }
  }
}

.payment-info {
  transition: translateY 0.3s ease;
}
